import CarsInStock from "@/pages/Dealers.vue";
import CarInStock from "@/pages/DealerViewCar.vue";

export default [
    {path: "/kjarabilar/", redirect:"/", name: "CarsInStock", component: CarsInStock},
    {path: "/kjarabilar/:id", redirect:"/", name: "CarInStock", component: CarInStock},
]